"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RatingFieldLogic = void 0;
var rating_fieldtype_1 = require("./rating.fieldtype");
Object.defineProperty(exports, "RatingFieldLogic", { enumerable: true, get: function () { return rating_fieldtype_1.RatingFieldLogic; } });
